// extracted by mini-css-extract-plugin
export default {"resetButton":"_4u9dMo","label":"ETkNLFi"};